import React from "react";
import CreateEvent from "../../components/Shop/CreateEvent";
import { server } from "../../server";

const ProfileCreateService = () => {
  return (
    <CreateEvent
      entityLabel="Service"
      entityLabelPlural="Services"
      apiBasePath={`${server}/service`}
      apiNamespace="service"
      successRedirectPath="/profile/services"
    />
  );
};

export default ProfileCreateService;
